/*PRIM-304 added to adjust the height for Safari users due to the safari utility tab in the bottom overlapped the buttom of the view for modalboxes */


export default class ModalOrder
{
  constructor () {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()
  }
}